/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
export default {
  name: 'myClasses',
  data() {
    return {
      loading: false,

      teacher_id: null,
      teacher_name: '',
      dialogCreate: {
        show: false,
        name: '',
      },

      tabs: {
        active: 'my',
        panes: [
          {
            label: '我的班级',
            name: 'my',
            list: [],
          },
          {
            label: '全部班级',
            name: 'all',
            list: [],
          },
        ],
      },
      panesData: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    document.querySelector('.el-tabs__nav-scroll').insertAdjacentHTML('beforeEnd', '<div class="el-button el-button--primary flex ac" onclick="showNewClass()"><i class="el-icon-plus" style="margin-right: 5px;"></i>新增班级</div>');
  },
  methods: {
    // 获取初始数据
    async init() {
      this.loading = true;
      // const user = await this.$http.get('/api/user')
      const user = this.$route.query;
      this.teacher_id = user.id;
      this.teacher_name = user.name;
      window.showNewClass = this.showNewClass;
      this.$http.get('/api/classes?is_show_student_list=1&per_page=9999&order[id]=desc').then((res) => {
        this.panesData = res.items;

        let _formData = localStorage.getItem('my_class_formdata');

        if (_formData) {
          _formData = JSON.parse(_formData);

          _formData.classes_ids && _formData.classes_ids.length && this.panesData.forEach(val => _formData.classes_ids.includes(val.id) && (val.chose = true));
        }

        this.tabsClass();
      }).finally(() => this.loading = false);
    },
    // 分类
    tabsClass() {
      const myList = [];

      this.panesData.forEach(val => `${val.teacher_id}` === `${this.teacher_id}` && myList.push(val));
      this.tabs.panes.forEach(val => val.list = val.name === 'my' ? myList : this.panesData);
    },

    // 新增 - 弹窗
    showNewClass() {
      this.dialogCreate.show = true;
    },

    // 新增 - 请求
    postNewClass() {
      if (!this.dialogCreate.name) {
        this.$message({
          message: '班级名称不能为空！',
          type: 'warning',
        });
        return;
      }

      this.loading = true;
      this.dialogCreate.show = false;

      this.$http.post('/api/classes', {
        name: this.dialogCreate.name,
        tag_remark: '',
        teacher_id: this.teacher_id,
      }).then((res) => {
        res.data.teacher = {
          name: this.teacher_name,
        };
        this.panesData.push(res.data);
        this.tabsClass();
      }).finally(() => this.loading = false);
    },

    // 选择
    onClass() {
      const _active = this.tabs.active;

      this.tabs.active = '';
      requestAnimationFrame(() => this.tabs.active = _active);
    },

    // 提交
    onSubmit() {
      const _data = [];

      this.panesData.forEach(val => val.chose && _data.push(val));

      localStorage.setItem('my_class_formclasses', JSON.stringify(_data));

      this.$router.back();
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/MyClass/MyClasses/index.js